import React, { Component } from 'react';
import PropTypes from "prop-types";
import SiteLayout from '../layouts/SiteLayout';
import Validator from "../services/Validation";
import AuthAction from "../actions/AuthAction";
import CommonAction from "../actions/CommonAction";
import UserAction from "../actions/UserAction";
import Cookie from "../services/Cookie";
import Mail from "../services/Mail";
import AuthCheck from "../services/AuthCheck";
import { toast } from "react-toastify";
import debounce from "lodash/debounce";
import find from "lodash/find";
import intersectionBy from "lodash/intersectionBy";
import filter from "lodash/filter";
import moment from "moment";
import { withRouter } from 'next/router';
import Link from 'next/link'
import SlackWebHook from "../services/Slack";
import Location from "../services/Location";
import { MdRemoveRedEye } from "@react-icons/all-files/md/MdRemoveRedEye";
import { MdArrowForward } from "@react-icons/all-files/md/MdArrowForward";
import SidebarCTA from '../components/SidebarCTA';
import SiteLoader from '../components/SiteLoader';

const roles = [{roleMachineName: 'users'}];

class Signup extends Component {

    static getInitialProps ({query}) {
        return {query};
    }

    constructor(props) {
        super(props);
        this.state = {
            rcaptId: null,
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            gender: "",
            countryId: "",
            password: "",
            cPassword: "",
            courseId: "",
            referralCode: "",
            courseExamDate: "",
            captcha: false,
            countryList: [],
            dateList: [],
            courseList: [],
            ipdata: {},
            validate: false,
            onLoad:false,
            source: '',
            pageLoading: true,
            referralDetails: null,
            referralDetailsLoading: false
        };
        this.debounceCodeCheck = debounce(this.codeCheck, 700, { 'maxWait': 5000 });
    }

    componentDidMount() {
        if(AuthCheck.checkCookie()){
            this.props.router.push('/dashboard');
        }else {
            if (process.env.NEXT_PUBLIC_REGISTRATION_ENABLE === undefined || process.env.NEXT_PUBLIC_REGISTRATION_ENABLE === "true") {
                const {source, firstName, lastName, email, mobile, referralCode} = this.props.query;
                this.setState({
                    ...this.state,
                    source: source ? source : "",
                    firstName: firstName ? firstName : "",
                    lastName: lastName ? lastName : "",
                    email: email ? email : "",
                    mobile: mobile ? mobile : "",
                    referralCode: (process.env.NEXT_PUBLIC_REFERRAL_CODE !== undefined && process.env.NEXT_PUBLIC_REFERRAL_CODE !== "") ? process.env.NEXT_PUBLIC_REFERRAL_CODE : referralCode ? referralCode : "",
                    pageLoading: false
                }, () => this.codeCheck());
                Location.getLocation().then((res) => {
                    if (res) {
                        setTimeout(() => {
                            if (document.getElementById("g-recaptcha")) {
                                let rcaptId = null;
                                var interval = setInterval(() => {
                                    if(window.grecaptcha){
                                        grecaptcha.ready(() => {
                                            rcaptId = grecaptcha.render(document.getElementById("g-recaptcha"),
                                                {
                                                    sitekey: process.env.NEXT_PUBLIC_RE_CAPTCHA,
                                                    callback: (res) => {
                                                        try {
                                                            if (res.length > 0 && grecaptcha.getResponse(this.state.rcaptId).length > 0) {
                                                                this.setState({
                                                                    ...this.state,
                                                                    captcha: true,
                                                                    validate: false
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    ...this.state,
                                                                    captcha: false,
                                                                });
                                                            }
                                                        } catch (err) {
                                                            console.log(err);
                                                        }
                                                    },
                                                }
                                            );
                                            this.setState({
                                                ...this.state,
                                                rcaptId: rcaptId,
                                            });
                                        });
                                        clearInterval(interval);
                                    }
                                }, 100);

                                this.setState({
                                    ...this.state,
                                    rcaptId: rcaptId,
                                    ipdata: JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails,
                                }, () => {
                                    this.init();
                                })
                            } else {
                                this.setState({
                                    ...this.state,
                                    captcha: true,
                                    ipdata: JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails,
                                }, () => {
                                    this.init();
                                })
                            }
                        }, 100);
                    }
                }).catch(err => SlackWebHook.sendSlackMessage('Signup', 'componentDidMount', `${err.message}`));
            }
            else{
                location.replace(process.env.NEXT_PUBLIC_REDIRECTION_URL + location.search + (location.search.trim() === '' ? '?' : '&') + 'platform=' + btoa(location.host));
            }
        }
    }

    init = () => {
        CommonAction.listCountry().then((res) => {
            let response = res.data.listCountry;
            if(response.code === "200" && response.status === "success") {
                var cntryId = find(response.data.countries, ['code', this.state.ipdata.country_code]).countryId;
                this.setState({
                    countryList: response.data.countries,
                    countryId: cntryId
                })
            }else {
                console.log(res);
            }
        }).catch((err) => {
            SlackWebHook.sendSlackMessage('Signup','init',`${err.message}`)
        });

        CommonAction.anonymousCourseList().then((res) => {
            let response = res.data.anonymousCourseList;
            if(response.code === "200" && response.status === "success") {
                this.setState({
                    courseList: filter(response.data, (c)=>{return c.courseId != 1}).reverse()
                })
            }else {
                console.log(res);
            }
        }).catch((err) => {
            SlackWebHook.sendSlackMessage('Signup','init',`${err.message}`)
        });
    }

    onChange = (e) => {
        e.persist();
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            validate: false
        }, () => {
            if(e.target.name === "courseId") {
                this.setState({
                    ...this.state,
                    courseExamDate: ""
                });
                CommonAction.getExamDateList(this.state.courseId).then((res) => {
                    let response = res.data.fetchExamDate;
                    if(response.code === "200" && response.status === "success") {
                        this.setState({
                            ...this.state,
                            dateList: response.data
                        })
                    }else {
                        console.log(res);
                    }
                }).catch((err) => {
                    SlackWebHook.sendSlackMessage('Signup','onChange',`${err.message}`)
                });
            }
            if(e.target.name === "referralCode") {
                this.debounceCodeCheck();
            }
        })
    };

    unmask = (selector) => {
        const eyeIcon = document.getElementById(selector);
        const passwordfield = document.querySelector('.' + selector + ' .password');
        const type = passwordfield.getAttribute('type') === 'password' ? 'text' : 'password';
        passwordfield.setAttribute('type', type);
        // toggle the icon
        eyeIcon.classList.toggle('active');
    }

    onSubmit = (e, flag='checkout') => {
        e.preventDefault();
        this.setState({
            ...this.state,
            validate: true,
            onLoad: true
        }, () => {
            this.validator().then((res) => {
                if(res){
                    const { firstName, lastName, email, password, mobile, countryId, gender, referralCode, courseId, courseExamDate, referralDetails, courseList, countryList } = this.state;
                    AuthAction.registerUser(firstName.trim(), lastName.trim(), email.trim(), password.trim(), mobile.trim(), countryId, gender, referralCode.trim(), courseId, courseExamDate).then((res) => {
                        let response = res.data.RegisterStudent;
                        if(response.code === "201" && response.status === "success") {
                            let payload = {
                                email,
                                firstName,
                                lastName,
                                referralDetails,
                            };
                            let message = `${firstName} ${lastName} (${email} ${mobile != "" ? find(countryList, ['countryId', parseInt(countryId)]).dialCode + ' ' + mobile : ""}) registered from ${JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails.city}, ${JSON.parse(localStorage.getItem('user_location_details_local')).geoLocationDetails.country_name} for ${find(courseList, ['courseId', parseInt(courseId)]).courseName}`
                            SlackWebHook.sendSlackMessage('', '', message, process.env.NEXT_PUBLIC_SLACK_URL, process.env.NEXT_PUBLIC_SLACK_USERNAME, process.env.NEXT_PUBLIC_SLACK_ADMIN_CHANNEL, ':walking::skin-tone-4:');
                            Mail.registration(payload);
                            toast.success("Setting up your account,do not refresh the page.");
                            this.login(flag);
                        }else {
                            this.setState({
                                ...this.state,
                                onLoad: false
                            })
                            toast.error(response.message);
                        }
                    }).catch((err) => {
                        this.setState({
                            ...this.state,
                            onLoad: false
                        })
                        toast.error(err.message);
                        SlackWebHook.sendSlackMessage('Signup','onSubmit',`${err.message}`)
                    });
                }else{
                    this.setState({
                        ...this.state,
                        onLoad: false
                    })
                    toast.error("Please fill the mandatory fields");
                }
            })
        })
    }

    login = (flag) =>{
        const { email, password } = this.state;
        AuthAction.loginUser(email.trim(), password.trim()).then((res) => {
            const response = res.data.loginUser;
            if (response.status === 'success' && response.code === '200') {
                const data = response.data;
                Cookie.setCookie('_token', data.accessToken, 7);
                let user = AuthCheck.checkAuth();
                let roleDetails = intersectionBy(Object.values(JSON.parse(user.roleDetails)), roles, 'roleMachineName');
                if (roleDetails.length === 1 && (process.env.NEXT_PUBLIC_ORGANIZATION_ID === undefined || process.env.NEXT_PUBLIC_ORGANIZATION_ID === "false" || parseInt(process.env.NEXT_PUBLIC_ORGANIZATION_ID) === parseInt(user.orgId))) {
                    if(this.props.query.next && this.props.query.next !== "") {
                        this.props.router.push(atob(this.props.query.next));
                    }else {
                        this.props.router.push(`/${flag}`);
                    }
                } else {
                    Cookie.deleteCookie('_token');
                    toast.error("You don't have access to this platform");
                }
                this.setState({
                    ...this.state,
                    onLoad: false
                })
            } else {
                SlackWebHook.sendSlackMessage('SignUp', 'login', `${response.message}`);
                this.setState({
                    ...this.state,
                    onLoad: false
                })
                toast.error(response.message);
            }
        }).catch((err) => {
            SlackWebHook.sendSlackMessage('SignUp', 'login', `${err.message}`);
            this.setState({...this.state, onLoad:false});
            toast.error('Something went wrong');
        });
    }

    validator = () => {
        return new Promise((resolve, reject) => {
            try{
                if(Validator.text(this.state.firstName.trim())
                    && Validator.text(this.state.lastName.trim())
                    && Validator.email(this.state.email.trim())
                    && Validator.text(this.state.gender)
                    && Validator.passwordStrength(this.state.password.trim(), "week")
                    && Validator.passwordStrength(this.state.cPassword.trim(), "week")
                    && this.state.password === this.state.cPassword
                    && Validator.text(this.state.courseExamDate)
                    && Validator.positiveNumber(this.state.countryId)
                    && Validator.positiveNumber(this.state.courseId)
                    && this.state.captcha){
                    if(this.state.countryId == 101 || process.env.NEXT_PUBLIC_PAYMENT_SOURCE === 'WETUTOR') {
                        if(Validator.mobile(this.state.mobile.trim())) {
                            resolve(true);
                        }else {
                            resolve(false);
                        }
                    }else {
                        resolve(true);
                    }
                }else {
                    resolve(false);
                }
            }catch(err){
                reject(err)
            }
        })
    }

    codeCheck = () => {
        const { referralCode } = this.state;
        let input = {
            referralCode: referralCode
        };
        this.setState({
            ...this.state,
            referralDetailsLoading: true
        }, () => {
            UserAction.agentDetails(input).then((res) => {
                let response = res.data.agentDetails;
                if(response.code === '200' && response.status === 'success'){
                    this.setState({
                        ...this.state,
                        referralDetails: response.data,
                        referralDetailsLoading: false
                    })
                }else {
                    this.setState({
                        ...this.state,
                        referralDetails: null,
                        referralDetailsLoading: false
                    });
                }
            }).catch( (err) => {
                this.setState({
                    ...this.state,
                    referralDetails: null,
                    referralDetailsLoading: false
                })
                SlackWebHook.sendSlackMessage('SignUp', 'codeCheck', `${err.message}`);
            });
        });
    }

    changeRoute = () => {
        let input = {
            next: this.props.query.next,
            referralCode: this.props.query.referralCode,
            email: this.props.query.email,
            source: this.props.query.source
        }
        this.props.router.push("/" + Validator.queryParamBind(input));
    }

    render() {
        const { firstName, lastName, email, mobile, gender, password, cPassword, countryId, courseId, courseExamDate, referralCode, captcha, countryList, courseList, dateList, validate, onLoad, source, pageLoading, referralDetails, referralDetailsLoading } = this.state;

        return (
            <SiteLayout>
                {
                    pageLoading &&
                    <SiteLoader />
                }
                <div id="signup" className="page-grid signup">
                    <SidebarCTA heading="Join the most advanced E-Learning Platform for the SAT & ACT" source={source} />
                    <div className="position-relative flex-center py-5 py-lg-4">
                        <div className='w-100 mt-md-5 mb-md-4'>
                            <div className="d-lg-none">
                                <Link href='/'>
                                    <a>
                                        <div className="logo-wrapper mx-auto mb-4">
                                            {
                                                source ?
                                                    <>
                                                        {
                                                            source == "scholarly" &&
                                                            <img width="110px" src="/images/scholarly-logo.png" alt="scholarly-logo" />
                                                        }
                                                        {
                                                            source == "corporategurukul" &&
                                                            <img width="110px" src="/images/corporategurukul-logo.png" alt="corporategurukul-logo" />
                                                        }
                                                    </>
                                                    :
                                                    <picture>
                                                        <source type="image/webp" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                                        <source type="image/png" srcSet={process.env.NEXT_PUBLIC_BRAND_LOGO} />
                                                        <img src={process.env.NEXT_PUBLIC_BRAND_LOGO} alt="brand-logo"/>
                                                    </picture>
                                            }
                                        </div>
                                    </a>
                                </Link>
                            </div>
                            <h3 className="text-center bold mb-4">Create an account</h3>
                            <div>
                                <section id="registerForm" className="mb-5">
                                    <div className="row justify-content-between">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="courseId-0" className="col-form-label mb-0">Course</label>
                                            <div className="flex-row align-items-center">
                                                {
                                                    courseList.length > 0 ?
                                                        courseList.map((course, index) => (
                                                            <label className="radio-wrapper mt-2 mr-3" key={index}>
                                                                <input type="radio" name="courseId" id={`courseId-${index}`} onChange={this.onChange} value={course.courseId} />
                                                                <span className={`checkmark radio ${(validate && (Validator.positiveNumber(courseId) ? '' : 'error')).toString()}`} />
                                                                <span htmlFor={`courseId-${index}`}>{course.courseName}</span>
                                                            </label>
                                                        ))
                                                        :
                                                        <div className="content-loading w-100 rounded" style={{height: 42}}></div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="courseExamDate" className="col-form-label">Select Exam Date</label>
                                            {
                                                dateList.length > 0 ?
                                                    <select id="courseExamDate"
                                                        className={`custom-select ${(validate && (Validator.text(courseExamDate) ? '' : 'error')).toString()}`}
                                                        disabled={!Validator.positiveNumber(courseId)} onChange={this.onChange}
                                                        name="courseExamDate" value={courseExamDate}>
                                                        <option value="">Select Date</option>
                                                        {
                                                            dateList.map((date, index) => (
                                                                <option value={date.examDate} key={index}>{moment(date.examDate).format("LL")}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    :
                                                    <select className="custom-select" id="courseExamDate" disabled>
                                                        <option value="">Select Your Course First</option>
                                                    </select>

                                            }
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="firstName" className="col-form-label">First Name</label>
                                            <input type="text" name="firstName" id="firstName"
                                                onChange={this.onChange}
                                                className={`form-control ${(validate && (Validator.text(firstName.trim()) ? '' : 'error')).toString()}`}
                                                placeholder="First Name"
                                                value={firstName}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="lastName" className="col-form-label">Last Name</label>
                                            <input type="text" name="lastName" id="lastName"
                                                onChange={this.onChange}
                                                className={`form-control ${(validate && (Validator.text(lastName.trim()) ? '' : 'error')).toString()}`}
                                                placeholder="Last Name"
                                                value={lastName}
                                            />
                                        </div>

                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="email" className="col-form-label">Email</label>
                                            <input type="email" name="email" id="email"
                                                className={`form-control ${(validate && (Validator.email(email.trim()) ? '' : 'error')).toString()}`}
                                                placeholder="Enter your Email"
                                                autoComplete="email"
                                                value={email}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="gender" className="col-form-label">Gender</label>
                                            <select id="gender"
                                                className={`custom-select  ${(validate && (Validator.text(gender.trim()) ? '' : 'error')).toString()}`}
                                                name="gender" value={gender} onChange={this.onChange}>
                                                <option value="">Select Gender</option>
                                                <option value="male">male</option>
                                                <option value="female">female</option>
                                                <option value="other">other</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div className="form-row mb-2 mb-md-1">
                                        <div className="col-md-6 ">
                                            <label htmlFor="password" className="col-form-label">Password</label>
                                            <div className="position-relative unmask-pass">
                                                <input type="password" name="password" id="password"
                                                    autoComplete="new-password"
                                                    className={`form-control password ${(validate && ((Validator.passwordStrength(password.trim(), "week") && password === cPassword) ? '' : 'error')).toString()}`}
                                                    placeholder="Enter a password "
                                                    value={password}
                                                    onChange={this.onChange}
                                                />
                                                <div id="unmask-pass" className="unmask" onClick={this.unmask.bind(this, "unmask-pass")}>
                                                    <MdRemoveRedEye fontSize="22px"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="cPassword" className="col-form-label">Confirm Password</label>
                                            <div className="position-relative unmask-cpass">
                                                <input type="password" name="cPassword" id="cPassword"
                                                    autoComplete="new-password"
                                                    className={`form-control password ${(validate && ((Validator.passwordStrength(cPassword.trim(), "week") && password === cPassword) ? '' : 'error')).toString()}`}
                                                    placeholder="Confirm same password"
                                                    value={cPassword}
                                                    onChange={this.onChange}
                                                />
                                                <div id="unmask-cpass" className="unmask" onClick={this.unmask.bind(this, "unmask-cpass")}>
                                                    <MdRemoveRedEye fontSize="22px"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="password-lines">
                                        <li>Min 6 Character needed. </li>
                                        <li>Also, We recommend using aphanumeric for storng password.</li>
                                    </ul>
                                    <div className="form-row">
                                        <div className={`form-group ${(process.env.NEXT_PUBLIC_REFERRAL_CODE === undefined || process.env.NEXT_PUBLIC_REFERRAL_CODE === "") ? 'col-md-4': 'col-md-6'} `}>
                                            <label className="col-form-label" htmlFor="country">Select Country</label>
                                            <select id="country"
                                                className={`custom-select ${(validate && (Validator.positiveNumber(countryId) ? '' : 'error')).toString()}`}
                                                name="countryId" value={countryId} onChange={this.onChange}>
                                                <option disabled>Select Country</option>
                                                {countryId != null && countryList.length > 0 && countryList.map((country, index) =>
                                                    <option
                                                        value={country.countryId}
                                                        defaultValue={country.countryId == countryId ? true : false }
                                                        key={index}>
                                                        {country.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        <div className={`form-group ${(process.env.NEXT_PUBLIC_REFERRAL_CODE === undefined || process.env.NEXT_PUBLIC_REFERRAL_CODE === "") ? 'col-md-4': 'col-md-6'}`}>
                                            <label htmlFor="mobile" className="col-form-label">
                                                    Contact Number
                                                {
                                                    countryId != 101 && process.env.NEXT_PUBLIC_PAYMENT_SOURCE !== 'WETUTOR' &&
                                                        <span> (Optional)</span>
                                                }
                                            </label>
                                            <div className="position-relative">
                                                <input type="text"
                                                    onChange={this.onChange}
                                                    className={`form-control mobile ${(validate && (countryId == 101 || process.env.NEXT_PUBLIC_PAYMENT_SOURCE === 'WETUTOR') && (Validator.mobile(mobile.trim()) ? '' : 'error')).toString()}`}
                                                    placeholder="Phone Number"
                                                    name="mobile" id="mobile"
                                                    value={mobile}
                                                />
                                                <p className="c-code txt-16--body lh-20">{filter(countryList, ['countryId', parseInt(countryId)]).length > 0 ? filter(countryList, ['countryId', parseInt(countryId)])[0].dialCode : '+91'}</p>
                                            </div>
                                        </div>
                                        {
                                            (process.env.NEXT_PUBLIC_REFERRAL_CODE === undefined || process.env.NEXT_PUBLIC_REFERRAL_CODE === "") &&
                                            <div className="form-group col-md-4">
                                                <label htmlFor="referralCode" className="col-form-label">Referral Code (Optional)</label>
                                                <input type="text" name="referralCode" id="referralCode"
                                                    className={`form-control ${referralCode !== "" && (referralDetails ? 'is-valid' : 'is-invalid')}`}
                                                    placeholder="Enter referral code"
                                                    value={referralCode}
                                                    onChange={this.onChange}
                                                />
                                                <div className="invalid-feedback">
                                                    Invalid code
                                                </div>
                                                <div className="valid-feedback">
                                                    Referred by {referralDetails?.firstName} {referralDetails?.lastName}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {
                                        process.env.NEXT_PUBLIC_HAS_CAPTCHA === "true" &&
                                        <div className="d-flex justify-content-center my-4">
                                            <div className="align-items-center">
                                                {
                                                    validate && !captcha &&
                                                    <span className="text-danger">*Captcha required</span>
                                                }
                                                <div id="g-recaptcha"></div>
                                            </div>
                                        </div>
                                    }
                                    {/* <div className='d-flex justify-content-center flexible-width mt-3 mx-auto'>
                                        <button className="btn-solid-large --primary w-100" disabled={onLoad || referralDetailsLoading} onClick={this.onSubmit}>
                                          Create an account
                                            <span className={`icon-btn--layer ${onLoad ? 'no-border' : 'primary-border'}`}>
                                                {onLoad ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                                            </span>
                                        </button>
                                    </div> */}
                                    {

                                        process.env.NEXT_PUBLIC_PAYMENT_SOURCE === 'COLLEGIFY'?
                                            <div className='justify-content-center flexible-width mt-3 mx-auto'>
                                                <button className="btn-solid-large --primary w-100" disabled={onLoad || referralDetailsLoading} onClick={this.onSubmit}>
                                                    <span>Sign Up & Pay</span>
                                                    <span className={`icon-btn--layer ${onLoad ? 'no-border' : 'primary-border'}`}>
                                                        {onLoad ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                                                    </span>
                                                </button>
                                                <button className="btn-link --primary mt-3 w-100" disabled={onLoad || referralDetailsLoading} onClick={(e) => this.onSubmit(e,'dashboard')}>
                                                Continue to Dashboard
                                                </button>
                                            </div>
                                        :
                                            <div className='justify-content-center flexible-width mt-3 mx-auto'>
                                                <button className="btn-solid-large --primary w-100" disabled={onLoad || referralDetailsLoading} onClick={(e) => this.onSubmit(e,'dashboard')}>
                                                    <span>Create an account</span>
                                                    <span className={`icon-btn--layer ${onLoad ? 'no-border' : 'primary-border'}`}>
                                                        {onLoad ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                                                    </span>
                                                </button>
                                            </div>
                                    }

                                </section>
                                <hr className="hr-25 mb-3" />
                                <h4 className="text-center bold">Already a member? &nbsp;
                                    <a className="inline-link text-primary pointer" onClick={this.changeRoute}>Log In</a>
                                </h4>
                            </div>
                            <div className='w-50 w-md-25 mx-auto'>
                                {
                                    (source && (source == "scholarly" || source == "corporategurukul")) &&
                                    <img src="/images/Powered-By.png" className='mx-auto w-auto' alt="powered-by" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </SiteLayout>
        )
    }
}

const propTypes = {
    router: PropTypes.object,
    query: PropTypes.object
}

Signup.propTypes = propTypes

export default withRouter(Signup);